export const SET_SERVICE_REQUESTS = 'Set service requests'
export const UPDATE_SERVICE_REQUEST = 'Update service request'
export const DELETE_SERVICE_REQUEST = 'Delete service request'
export const SET_DIAGNOSTIC_REPORTS = 'Set reports'
export const SET_DIAGNOSTIC_DEVICES = 'Set devices'
export const DELETE_DIAGNOSTIC_REPORT = 'Delete diagnostic'
export const UPDATE_DIAGNOSTIC_REPORT = 'Update diagnostic'
